export const resolveUrl = url => {
    const parts = window.location.pathname.match(/(\/.*)\/(products|categories)/m);
    const part = parts ? parts[1] : '/shop/us/en';
    const cleanUrl = url[0] === '/' ? url : `/${url}`;
    return part + cleanUrl;
};
